import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  grantAnalyticsConsent,
  denyAnalyticsConsent,
  hasConsentChoice,
  subscribeToConsent,
} from '../../utils/analytics';

const ConsentBanner = () => {
  const [visible, setVisible] = useState(() => !hasConsentChoice());

  useEffect(() => {
    return subscribeToConsent(() => {
      setVisible(!hasConsentChoice());
    });
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    grantAnalyticsConsent();
    setVisible(false);
  };

  const handleDecline = () => {
    denyAnalyticsConsent();
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-lg"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row sm:items-center gap-4">
        <p className="flex-1 text-sm text-gray-700 dark:text-gray-300">
          We use Google Analytics to understand which tools are used and improve SwiftToolsKit.
          No advertising cookies. See our{' '}
          <Link to="/privacy" className="text-primary-600 dark:text-primary-400 underline">
            Privacy Policy
          </Link>
          .
        </p>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            type="button"
            onClick={handleDecline}
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="px-4 py-2 text-sm font-medium text-white bg-gradient-primary hover:opacity-90 rounded-md transition-opacity"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
